var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeakerIconinline = function SvgSpeakerIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    x: 5.5,
    y: 5.5,
    stroke: "#2B4BEE",
    strokeWidth: 3,
    rx: 30.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B4BEE",
    d: "M3.5 3.5h65v65h-65z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2B4BEE",
    strokeWidth: 2,
    d: "M1 1h9v9H1zM62 1h9v9h-9zM1 62h9v9H1zM62 62h9v9h-9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#speaker-icon_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.541 21.159a1 1 0 0 0-.955-.07L33.783 26H27a7 7 0 1 0 0 14h6.783l10.8 4.91A1 1 0 0 0 46 44V22a1 1 0 0 0-.459-.84M48 29v8a4 4 0 1 0 0-8M33.252 42h-5.775l3.386 8.329a2.664 2.664 0 0 0 4.944-1.986z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "speaker-icon_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 20h32v32H20z"
  })))));
};
export default SvgSpeakerIconinline;